module.exports = {
	"es": {
		"help-tool": {
			"button-text": "Ayuda",
			"support-button": "Obtener ayuda",
			"support-page": {
				"create-ticket": {
					"title": "Obtener ayuda",
					"instructions": "Envía una petición a continuación y te contactaremos en un plazo de 1 día hábil.",
					"related-content": {
						"title": "Esto podría solucionar tu problema"
					},
					"fields": {
						"mid": {
							"label": "Seleccionar tienda",
							"validation": "La tienda es necesaria"
						},
						"phoneNumber": {
							"label": "Número de teléfono (opcional)"
						},
						"topic": {
							"question": "¿Cuál es el tema de tu pregunta?",
							"label": "Selecciona un tema",
							"validation": "El tema es necesario",
							"options": {
								"orders": "Pedidos",
								"settlements": "Liquidaciones",
								"agreements": "Acuerdos",
								"others": "Otros"
							}
						},
						"subject": {
							"label": "Asunto",
							"validation": "El asunto es necesario"
						},
						"description": {
							"label": "Mensaje",
							"validation": "La descripción es necesaria"
						},
						"attachment": {
							"label": "Añadir archivos adjuntos",
							"button": "Cargar",
							"info": "Si añades capturas podremos resolver el problema más rápido.",
							"supportedFileTypes": "Formatos admitidos: .png, .jpg, .pdf",
							"error": "El tamaño máximo del total de archivos es de {maxSize} MB"
						}
					},
					"submit": "Enviar petición",
					"service-unavailable-error": "¡Vaya! Se produjo un error, inténtalo de nuevo en unos minutos. Si el problema continúa, {link} y te ayudaremos.",
					"generic-error": "No se pudo procesar tu petición. No hay comunicación entre nuestros sistemas en este momento. Vuelve a cargar la página o inténtalo más tarde. Si el problema continúa, {link} y te ayudaremos.",
					"contact-link": "contáctanos"
				},
				"view-ticket": {
					"title": "¡Ya está!",
					"details": "Hemos recibido tu petición y te responderemos en un plazo de 1 día hábil. Estos son los detalles:",
					"ticket": "N.º de petición {ticketId}",
					"email": "Email: {email}",
					"status": "Puedes ver el estado en nuestra página de ayuda.",
					"track": "Seguimiento del estado"
				}
			},
			"header": {
				"homeLink": "Restablecer"
			},
			"home": {
				"greeting": "Hola, {givenName}: ¿Cómo podemos ayudarte?",
				"topics": "¿Con qué necesitas ayuda?"
			},
			"topics": {
				"expandButton": "Más"
			},
			"feedback": {
				"title": "¿Te ha resultado útil?",
				"optionYes": "Sí, ha sido útil",
				"optionNo": "No, necesito más ayuda",
				"positiveFeedback": "Gracias por tus comentarios positivos, nos ayudan a ofrecerte artículos más útiles en el futuro."
			},
			"freeTextFeedback": {
				"title": "Ayúdanos a mejorar",
				"placeholder": "¿Por qué no te ha resultado útil este contenido?",
				"submitButton": "Enviar",
				"feedbackMessage": "Gracias por tus comentarios, nos ayudan a ofrecerte artículos más útiles en el futuro."
			},
			"relatedContent": {
				"title": "Contenido relacionado"
			},
			"search": {
				"buttonLabel": "Buscar",
				"input": "Buscar artículos...",
				"loading": "Cargando...",
				"results": {
					"contact": "¿No encuentras lo que buscas?",
					"empty": "Lo sentimos, no hemos encontrado ningún resultado para tu búsqueda. Intenta buscar otro término.",
					"singleTopicFound": "Hemos encontrado 1 entrada",
					"multipleTopicsFound": "Hemos encontrado {count} entradas",
					"singleArticleFound": "Hemos encontrado 1 artículo",
					"multipleArticlesFound": "Hemos encontrado {count} artículos"
				}
			},
			"contact": {
				"title": "Contactar",
				"channelsIntro": "Ponte en contacto con nosotros para que te echemos una mano.",
				"businessDetailsTitle": "Los datos de tu empresa",
				"businessDetailsName": "Nombre de la empresa",
				"businessDetailsEmail": "Correo electrónico",
				"businessDetailsMid": "ID del comercio",
				"phone": {
					"title": "Llámanos",
					"paragraph": "Puedes llamarnos durante nuestro horario comercial entre semana. Si estás en Suecia o Reino Unido, también puedes llamarnos los fines de semana entre las 10:00 h y las 16:00 h."
				},
				"email": {
					"title": "Envíanos un e-mail",
					"paragraph": "Mándanos un e-mail y te responderemos lo antes posible."
				}
			},
			"errorBoundary": {
				"title": "Se ha producido un error",
				"message": "Lo sentimos, se produjo un error. Haz clic en el botón \"Atrás\" siguiente para regresar a la ayuda o en el botón \"Pedir ayuda\" para contactar con nosotros.",
				"resetButton": "Atrás",
				"errorId": "ID del error: {errorId}"
			},
			"tour": {
				"prev": "Anterior",
				"next": "Siguiente",
				"done": "Hecho"
			},
			"notAvailableMobile": {
				"title": "No disponible",
				"buttonBack": "Atrás",
				"paragraph": "Este contenido no está disponible en tu dispositivo. Intenta abrirlo en un dispositivo con una pantalla más grande, como un ordenador de sobremesa."
			},
			"shareButton": {
				"title": {
					"article": "Compartir un enlace en profundidad con este artículo",
					"topic": "Compartir un enlace en profundidad con este tema",
					"tour": "Compartir un enlace en profundidad con esta visita"
				},
				"radioItemHome": "Inicio de la app",
				"descriptionHome": "Abre el artículo de ayuda en la página de inicio del portal del comercio",
				"radioItemCurrent": "Página actual",
				"descriptionCurrent": "Abre el artículo de la ayuda en la página actual"
			},
			"marketSelector": {
				"whichMarketToContact": "¿Con qué mercado te gustaría ponerte en contacto?"
			}
		},
		"orientation": {
			"title": "Aprende a..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "¡Hola, {name}! 👋 Soy tu asistente de Klarna.",
				"whatDoYouNeedHelpWithPart2": "En muchos casos, te ayudaré a resolver tus dudas en menos de 5 minutos.",
				"whatDoYouNeedHelpWithPart3": "¿Con qué puedo ayudarte hoy?",
				"selectSupportChannel": "Selecciona un canal para ponerte en contacto con nuestro servicio de soporte.",
				"selectPayoutIssue": "¡Perfecto! Selecciona un tema relacionado con los pagos 👇",
				"selectOrderIssue": "¡Perfecto! Selecciona un tema relacionado con los pedidos 👇",
				"capturedOrders": "¿Tienes algún pedido {link1}?",
				"capturedOrdersLink1": "capturado",
				"notPaidOrder": {
					"isScheduleFollowed": "¿Se está respetando tu {link1} (incluidas las demoras del pago)?",
					"isScheduleFollowedLink1": "calendario de pagos",
					"isHoldbackOrDebt": "Si se ha superado la demora del pago, consulta tu {link1}. ¿Hay alguna retención o deuda debido a devoluciones/anulaciones?",
					"isHoldbackOrDebtLink1": "último archivo de liquidación"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Comprueba la fecha de captura de los pedidos que esperabas recibir y ten en cuenta la demora del pago. Puedes encontrar tus pedidos {link1}. ¿Se han capturado los pedidos por los que esperas recibir el pago?",
					"isScheduleFollowedLink1": "aquí"
				},
				"changePaymentFrequency": "¿Has recibido más de 30 pedidos capturados al mes durante un periodo de 3 meses?",
				"whenWillGetPaid": "La fecha de pago dependerá de tu calendario de pagos y de la demora del pago dispuestos en tu contrato (Condiciones generales). Si tienes dudas acerca de la configuración de tus pagos, puedes comprobarla en {link1}. ¿Se está respetando el calendario de pagos (+ las demoras del pago)?",
				"whenWillGetPaidLink1": "Liquidaciones",
				"thatHelped": "Gracias por tus comentarios positivos, nos ayudan a ofrecerte ayuda más relevante en el futuro. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "¡Ya veo! ¿Tienes algún pedido sin capturar?",
					"haveUncapturedOrdersPart2": "Si no sabes cómo comprobarlo, ve a {link1}.",
					"haveUncapturedOrdersPart2Link1": "esta página",
					"expirationDateSurpassed": "¿Se ha superado la fecha de caducidad? (generalmente 28 días)",
					"customerCreditPaymentMethod": "¿El cliente ha elegido un método de pago de crédito (factura, cuenta, domiciliación bancaria)?",
					"isOrderCaptured": "¿El pedido está {link1}?",
					"isOrderCapturedLink1": "capturado"
				}
			},
			"options": {
				"payout": "Pago",
				"orders": "Pedidos",
				"otherIssue": "Otros problemas",
				"whenPaidOrderNext": "¿Cuándo se me pagará la próxima vez?",
				"notPaidOrder": "No me han pagado",
				"paidWrongAmount": "Se me ha pagado una cantidad errónea",
				"changeHowOftenPaid": "Quiero cambiar la frecuencia con la que se me paga",
				"dontKnowHowToCaptureOrder": "No sé cómo capturar un pedido",
				"missedCaptureDeadline": "Se me ha pasado la fecha límite de captura",
				"needToRefundAnOrder": "Necesito devolver un pedido",
				"yes": "Sí",
				"no": "No",
				"partially": "Parcialmente",
				"iNeedMoreHelp": "Necesito más ayuda",
				"thatHelped": "Esto me ha ayudado",
				"contactSupportChannel": "Contacta con los canales de soporte"
			},
			"explanations": {
				"noCapturedOrders": "Primero, necesitas {link1}. Una vez hayas capturado el pedido, abonaremos el importe en tu cuenta bancaria. Las comisiones, las devoluciones y el resto de cargos se deducirán de dicho importe.",
				"noCapturedOrdersLink1": "capturar un pedido",
				"feesReturnsHoldbacks": "Las comisiones, las devoluciones y el resto de cargos podrían deducirse del importe del pago. Comprueba si tienes alguna retención o deuda debido a devoluciones/anulaciones en el {link1}.",
				"feesReturnsHoldbacksLink1": "último archivo de liquidación",
				"notPaidOrder": {
					"scheduleFollowed": "Una vez hayas capturado el pedido, abonaremos el importe en tu cuenta bancaria de acuerdo con tu calendario de pagos. Las comisiones, las devoluciones y el resto de cargos se deducirán de dicho importe. Consulta el valor del pago en el {link1}.",
					"scheduleFollowedLink1": "último archivo de liquidación",
					"noHoldback": "Comprueba que tienes los datos de la cuenta bancaria correctos registrados para la moneda del pago {link1}.",
					"noHoldbackLink1": "aquí",
					"withHoldback": "Si el valor de los pedidos capturados supera el de la deuda, comprueba que tienes los datos de la cuenta bancaria correctos registrados para la moneda del pago {link1}.",
					"withHoldbackLink1": "aquí"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Recibirás el próximo pago de acuerdo con el calendario de pagos + las demoras del pago."
				},
				"changePaymentFrequency": {
					"isAble": "Para proceder, contacta con nuestro servicio de soporte a través de los siguientes canales.",
					"isUnable": "Lamentablemente, no cumples con los requisitos necesarios para cambiar tu calendario de pagos."
				},
				"orders": {
					"uncapturedDynamicYes": "Veo que tienes {number} pedidos sin capturar.",
					"uncapturedDynamicNo": "Veo que no tienes pedidos sin capturar.",
					"uncapturedYesPart1": "¡Es hora de capturar algunos pedidos! Para ello,",
					"uncapturedYesPart2": "1. Dirígete a la página de pedidos {link1}.",
					"uncapturesYesPart2Link1": "haciendo clic aquí",
					"uncapturedYesPart3": "2. Haz clic en la referencia Klarna del pedido que quieres capturar",
					"uncapturedYesPart4": "3. Elige los artículos o añade la cantidad que quieras capturar",
					"uncapturedYesPart5": "4. Pulsa “Capturar”",
					"uncapturedNoPart1": "Para capturar un pedido, primero tienes que tener pedidos por capturar.",
					"uncapturedNoPart2": "Capturar un pedido significa que confirmas que el pedido se ha enviado al cliente. Esto debe hacerse siempre el mismo día que se envíe el pedido, para cada pedido. Cuando capturas un pedido, también nos indicas que debemos pagarte ese pedido. Puedes leer más cosas sobre cómo capturar un pedido {link1}.",
					"uncapturedNoLink1": "aquí",
					"customerCreditPaymentMethodNo": "Lamentablemente, no podemos ampliar un pedido que ha caducado. Tendrás que volver a crear el pedido.",
					"expirationDateSurpassedYes": "Para ayudarte a ampliar el pedido, ponte en contacto con nuestro servicio de soporte a través de uno de los siguientes canales.",
					"expirationDateSurpassedNo": "Ve a {link1}. Selecciona el pedido haciendo clic en la casilla junto al número de referencia de Klarna. Haz clic en Ampliar fecha de caducidad y confirma tu solicitud.",
					"expirationDateSurpassedNoLink1": "Pedidos > Por capturar",
					"isOrderCapturedYesPart1": "Selecciona los artículos que quieras devolver y haz clic en Devolución. También puedes hacer clic primero en Devolución y después indicar el importe que deseas devolver. Entre estas dos opciones, elige la que prefieras.",
					"isOrderCapturedYesPart2": "Tu cliente recibirá el importe que ya ha pagado en un plazo de 2-5 días hábiles. Observarás que este importe se descuenta de tu próximo pago.",
					"isOrderCapturedNo": "Si tienes un pedido sin capturar que no vas a enviar, puedes {link1} el pedido completo. Ve a la {link2} y haz clic en Cancelar pedido.",
					"isOrderCapturedNoLink1": "cancelar",
					"isOrderCapturedNoLink2": "página del pedido",
					"refundPartiallyCaptured": "Si has capturado parcialmente el pedido respecto a los artículos que has enviado, pero no vas a completar el resto, debes anular la parte no capturada del pedido. Ve a la {link1}, haz clic en Más acciones y selecciona Anular.",
					"refundPartiallyCapturedLink1": "página del pedido"
				}
			},
			"messages": {
				"sorryToHearThat": "Lamentamos no haber sido de ayuda. En breve se te redirigirá para contactar con nuestro servicio de soporte."
			},
			"button": {
				"label": "Contactar con el servicio de soporte"
			},
			"contact": {
				"chat": "Chatear con un agente",
				"ticket": "Enviar una incidencia",
				"times": {
					"minutes": "Tiempo de espera: {time} minuto(s)",
					"hours": "Tiempo de espera: {time} hora(s)",
					"days": "Tiempo de espera: {time} días(s)"
				}
			}
		}
	}
};